import { officeSearchForSlug } from '@/lib/officeSearch'
import { createFileRoute, redirect } from '@tanstack/react-router'

// PET-2999: the list is now one merged view across every office the company
// works with. This path survives because it is what every quote email sent
// before the merge points at.
export const Route = createFileRoute('/_contractor/$tenantSlug/quotes/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/quotes', search: officeSearchForSlug(params.tenantSlug) })
  },
})
